import { PropsWithChildren, ReactNode } from "react";

import { Label } from "../../ui/label";

type FieldWrapperProps = {
  id: string;
  label?: string;
  subLabel?: string;
  isRequired?: boolean;
  errorMessage?: string;
  className?: string;
  childrenContainerClassName?: string;
  labelRight?: ReactNode;
} & PropsWithChildren;
const FieldWrapper = ({
  id,
  label,
  subLabel,
  isRequired,
  errorMessage,
  children,
  className = "",
  childrenContainerClassName,
  labelRight,
}: FieldWrapperProps) => {
  return (
    <div className={className}>
      <div className="mb-2">
        {(label || labelRight) && (
          <div className="flex items-center justify-between">
            {label && (
              <Label htmlFor={id} className="block text-sm font-semibold">
                {label} {isRequired && <span className="text-destructive">*</span>}
              </Label>
            )}
            {labelRight}
          </div>
        )}

        {subLabel && <p className="text-muted-foreground text-xs">{subLabel}</p>}
      </div>

      <div className={childrenContainerClassName}>{children}</div>

      {errorMessage && (
        <p className="mt-1 text-sm text-destructive">{errorMessage}</p>
      )}
    </div>
  );
};

export default FieldWrapper;
